import React from "react";
import { withTranslation } from "react-i18next";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import { ManagementTitleCard } from "../../components/ManagementTitleCard/ManagementTitleCard";
import { HashLink } from "react-router-hash-link";
import ManagementBoss from "../Home/management-boss.webp";
import ManagementMonika from "../Home/monika.webp";
import ManagementGoszczynski from "../Home/goszczynski.webp";
import Dell from "../Home/dell_dark.webp";
import Microsoft from "../Home/microsoft_dark.webp";
import IBM from "../Home/ibm_dark.webp";
import AMD from "../Home/AMD.png";
import Actina from "../Home/Actina_czarne.png";
import Terra from "../Home/terra-logo.png";
import EKMA from "../Home/EKMA.jpg";
import IFR from "../Home/IFR-logo_2019-RGB-v1.png";
import Samsung from "../Home/Samsung.png";
import Subiekt from "../Home/subiekt.png";
import Insert from "../Home/insert.png";
import "./Relacje.sass";

const expertArticles = [
  { activityId: "7473416719370240000" },
];

class Relacje extends React.Component {
  componentDidMount() {
    document.title = "Relacje i Zaufanie — BluHolding";
  }

  render() {
    const { t } = this.props;
    return (
      <div>
        <Header />
        <div className="Home Relacje">
          <h1 className="Subpage__title">{t("relationsPageTitle")}</h1>

          <section className="section">
            <div className="section__block section__block--white text-center">
              <p>{t("relationsIntro")}</p>
            </div>
          </section>

          <section className="section--gray">
            <div className="w100 flex justify-center">
              <h2>{t("management")}</h2>
            </div>
            <ManagementTitleCard
              name="Krzysztof Błaszkiewicz"
              title={t("ceo")}
              image={ManagementBoss}
              bio={t("managementKrzysztofBio")}
            />
            <ManagementTitleCard
              name="Monika Błaszkiewicz"
              title={t("managementMonikaPosition")}
              image={ManagementMonika}
              bio={t("managementMonikaBio")}
            />
            <ManagementTitleCard
              name="Maciej Goszczyński"
              title={t("managementMaciejPosition")}
              image={ManagementGoszczynski}
              bio={t("managementMaciejBio")}
            />
          </section>

          <section className="section">
            <div className="w100 flex justify-center">
              <h2>{t("partners")}</h2>
            </div>
          </section>
          <div className="baner">
            <img src={Dell} alt="Dell" />
            <img src={Microsoft} alt="Microsoft" />
            <img src={IBM} alt="IBM" />
            <img src={AMD} alt="AMD" />
            <img src={Actina} alt="Actina" />
            <img src={Terra} alt="Terra" />
            <img src={EKMA} alt="EKMA" />
            <img src={IFR} alt="IFR" />
            <img src={Samsung} alt="Samsung" />
            <img src={require("../Home/streamsoft.png")} alt="Streamsoft" />
            <img src={Subiekt} alt="Subiekt" />
            <img src={Insert} alt="InsERT" />
          </div>

          <section className="section--gray">
            <div className="w100 flex justify-center">
              <h2>{t("relationsTrustHeading")}</h2>
            </div>
            <div className="section__block section__block--white text-center">
              <p>{t("relationsTrustDesc")}</p>
              <div className="Subpage__cta__buttons">
                <HashLink to="/#certyfikaty" className="button--primary">{t("certificates")}</HashLink>
                <HashLink to="/#referencje" className="button--primary">{t("recommendations")}</HashLink>
                <HashLink to="/#csr" className="button--primary">{t("csr")}</HashLink>
                <HashLink to="/#wyroznienia" className="button--primary">{t("awards")}</HashLink>
              </div>
            </div>
          </section>

          <section className="section--gray">
            <div className="Relacje__articles">
              {expertArticles.map((article) => (
                <iframe
                  key={article.activityId}
                  src={`https://www.linkedin.com/embed/feed/update/urn:li:activity:${article.activityId}`}
                  height="570"
                  width="504"
                  frameBorder="0"
                  allowFullScreen=""
                  title={t("expertArticleEmbedTitle")}
                  loading="lazy"
                ></iframe>
              ))}
            </div>
          </section>

          <section className="section">
            <div className="Subpage__cta">
              <div className="Subpage__cta__buttons">
                <HashLink to="/#kontakt-formularz" className="button--primary">
                  {t("relationsCtaContact")}
                </HashLink>
              </div>
            </div>
          </section>
        </div>
        <Footer />
      </div>
    );
  }
}

export default withTranslation()(Relacje);
